export {
  LandingHeader,
  LandingHeaderImage,
  LandingHeaderLottie,
  LandingHeaderTitle,
  LandingHeaderSubtitle,
  LandingHeaderPoints,
  LandingHeaderSeeMoreWrapper,
} from './LandingHeader';
